import { WizTranslationManager } from './wiz-translation.manager';
import { WizComponentTranslationObj } from '../../obj/translation/wiz-translation.obj';


/**
 * WizTranslableProperty
 * @param translatedProperty (property that needs to be changed)
 * The decorator overrides the set function to prevent the WizTranslateManage from a change of key
 */
export function WizTranslableProperty(translatedProperty): MethodDecorator  {
  return function(target: Function, property: string, descriptor: PropertyDescriptor) {
    // tslint:disable-next-line:prefer-const
    return {
      set(value) {
       // Add or update WizComponentTranslationVO
        if (value!=null) { // on filtre les valeurs nulles ou undefined. On veut garder chaine vide ('')
          WizTranslationManager.getInstance().componentReference(this, new
          WizComponentTranslationObj(this, String(value), translatedProperty, property));
        }
        // Call setter of component
        descriptor.set.bind(this)(value);
      },
      get() {
        // Call getter of component
        return descriptor.get.bind(this)();
      },
      enumerable: true,
      configurable: true
    };
  };
}
